import {
  loopbackGet,
  loopbackPut,
  loopbackPost,
  loopbackDelete,
} from '..';
import {
  ReviewRequest,
  ReviewCategory,
  ExtendedReview,
  CommentReview,
  Review,
  ReviewHistory,
  QuipUser,
  Trial,
  ReviewSubmissionData,
  PartialBy,
} from '../../redux/types';
import { TextblockReviewComment } from '../../redux/types/TextblockReviewCommentTypes';

type ExtendedReviewRequest = ReviewRequest & {
  assignee: QuipUser;
  trial: Trial;
}

export const getReviewRequests = (trialId: number): Promise<ExtendedReviewRequest[]> => {
  const filter = { where: { trialId }, include: ['assignee', 'trial'] };
  return loopbackGet(`ReviewRequests?filter=${JSON.stringify(filter)}`);
};

export const removeReviewRequest = (request: ReviewRequest): Promise<unknown> => (
  loopbackPut(`ReviewRequests/${request.id}`, { ...request, closed: true })
);

export const restoreReviewRequest = (request: ReviewRequest): Promise<unknown> => (
  loopbackPut(`ReviewRequests/${request.id}`, { ...request, closed: false })
);

export const addReviewRequest = (reviewerId: number, trialId: number): Promise<unknown> => (
  loopbackPost('ReviewRequests', { assigneeId: reviewerId, trialId })
);

export const getReviewRequestSubmissions = (
  requestId: number,
  trialId: number,
  locale: string,
): Promise<ReviewSubmissionData> => loopbackGet(`ReviewRequests/${requestId}/submissions/${trialId}?locale=${locale}`);

export const getReviewCategories = (): Promise<ReviewCategory[]> => (
  loopbackGet('ReviewCategories')
);

export const getExtendedReview = async (trialId: number): Promise<ExtendedReview[]> => {
  const filter = {
    where: {
      trialId,
    },
  };
  const uri = `ExtendedReviews?filter=${encodeURIComponent(JSON.stringify(filter))}`;
  return loopbackGet(uri);
};

export const uploadExtendedReview = (
  trialId: number, data: CommentReview,
): Promise<ExtendedReview> => {
  const payload = {
    data,
    trialId,
  };
  return loopbackPost('ExtendedReviews/uploadMultiblockComment', payload);
};

export const clearAllExtendedPayload = (trialId: number): Promise<Review[]> => loopbackGet(`Reviews/clearAllExtendedPayload?trialId=${trialId}`);

export const saveReviewHistory = (reviewHistory: ReviewHistory) => loopbackPost('ReviewHistories', reviewHistory);

export const submitReview = (review: Review) => (
  review.id
    ? loopbackPut('Reviews', review)
    : loopbackPost('Reviews', review)
);

export const getTextblockReviewCommentByEnrollmentId = (
  enrollmentId: number,
): Promise<TextblockReviewComment[]> => {
  const filter = {
    where: {
      enrollmentId,
    },
  };
  const uri = `TextblockReviewComments?filter=${encodeURIComponent(JSON.stringify(filter))}`;
  return loopbackGet(uri);
};

export const addUpdateTextblockReviewComment = (payload: PartialBy<TextblockReviewComment, 'id'>): Promise<TextblockReviewComment> => loopbackPost('TextblockReviewComments/addOrUpdateTextblockReview', payload);

export const checkTextblockReviewCommentExists = async (
  trialId: number,
): Promise<{count: number}> => loopbackGet(`TextblockReviewComments/count?where[trialId]=${trialId}`);

export const deleteAllTextblockCommentsByTrialId = (trialId: number) => loopbackGet(`TextblockReviewComments/deleteAllCommentsByTrialId?trialId=${trialId}`);

export const deleteExtendedReview = (id: number): Promise<void> => loopbackDelete(`ExtendedReviews/${id}`);
